import styled from "styled-components";
import type { FixeFooterStyleProps } from "./interface";

export const FixedFooterContainer = styled.div<FixeFooterStyleProps>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: ${({ borderNone }) => (borderNone ? "none" : "1px solid var(--border)")};
  padding: 16px;
  background-color: white;
  z-index: 50;
`;
